import {useState} from 'react'
import GlobalGapForm from './GlobalGapForm';
import GlobalGapList from './GlobalGapList';

const GlobalGap = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <GlobalGapForm addForm={setFromIsShown} update={upData} />
        ) : (
          <GlobalGapList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default GlobalGap